<template>
  <article class="CardSucesso w-100">
    <div class="card">
      <div data-v-21f0c8be="" class="card-body mb-5 p-5 text-center">
        <img
          src="https://pagglo-cdn.s3.amazonaws.com/app/assets/icon_success.png"
          style="
            background-color: green;
            border-radius: 100px;
            padding: 8px;
        "
        />
        <h4 class="my-3">O pagamento foi confirmado.</h4>
        <span>Obrigado pela sua compra!</span>
      </div>

      <div class="card-body">
        O pagamento foi confirmado. Obrigado pela sua compra! Você receberá uma
        notificação sobre o pedido de compra por e-mail.
      </div>
      <img style="display: none;" />
    </div>
    <div class="mt-3 mb-5 text-right">
      <router-link
        :to="{ path: `/loja` }"
        tag="button"
        class="btn btn-secondary px-5"
      >
        VOLTAR
      </router-link>
    </div>
  </article>
</template>

<script>
export default {
  name: "CardSucesso",
  props: {},
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  border-radius: 0 0 0.25rem 0.25rem;
}
</style>
